<button
    [matTooltip]="ttTooltip ?? ''"
    matTooltipShowDelay="1000"
    tabindex="-1"
    type="button"
    class="tt-input__button"
    (click)="onButtonClick($event)"
    [ngStyle]="style['button']"
    [ngClass]="classes"
    [disabled]="ttDisabled"
>
    <span class="fa-fw" [ngClass]="ttIcon" [ngStyle]="style['icon']"></span>
</button>
